<template>
  <div class="memberProperty" :style="boxStyle">
        <div class="title">
            <div class="welcome">{{ content.titleText }}</div>
            <div class="order">我的订单<span class="iconfont shair-yyok__arrow_icon"></span></div>
        </div>
        <div class="member">
            <div class="head">
                
            </div>
            <div class="name">碎风</div>
            <div class="privilege"><i class="s-iconfont shair-diamond_icon"></i>特权</div>
        </div>
        <div class="property">
            <div class="item"><span class="label">会员卡</span><span class="value">1</span></div>
            <div class="item"><span class="label">套餐</span><span class="value">3</span></div>
            <div class="item"><span class="label">红包</span><span class="value">3</span></div>
            <div class="item"><span class="label">积分</span><span class="value">3100</span></div>
        </div>
    </div>
</template>

<script>

import mixins from '../mixins/mixins'
export default {
  name: 'memberProperty',
  props: {},
  components: {},
  mixins: [mixins],
  data() {
    return {
      detailData: {
      },
      pattern: {},
      content: {},
    }
  },
  watch: {
  },
  computed: {
    boxStyle(){
      let obj = {
        "margin-left": (this.pattern.margin || 0) + 'px',
        "margin-right": (this.pattern.margin || 0) + 'px',
      }
      if(this.content.img&&this.content.img.url){
        obj["background-image"] = `url("${this.content.img.url}")`
      }
      return obj
    },
  },
  methods: {
    async init() {
      this.detailData = await this._filter(this.itemData)
      this.pattern = this.detailData.pattern || {}
      this.content = this.detailData.content || {}
      console.log("memberProperty----------this.detailData");
      console.log(this.detailData);
    },
  },
  async mounted() {
    
  }
}
</script>
<style lang="scss" scoped>
.memberProperty{
  height: 137px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  background-image: url("../image/memberProperty.png");
  padding: 8px;
  background-size: cover;
  background-position: center;
  .title {
      height: 22px;
      position: relative;
      .welcome {
          display: inline-block;
          max-width: 70%;
          height: 22px;
          background-color: #fff;
          border-radius: 22px;
          font-size: 12px;
          color: #333;
          font-weight: 400;
          line-height: 22px;
          padding: 0 15px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
      }
      .order {
          position: absolute;
          top: 0;
          right: 0;
          height: 22px;
          line-height: 22px;
          font-weight: 400;
          font-size: 12px;
          color: #9E9E9E;
          .iconfont {
              font-size: 12px;
              margin-left: 6px;
          }
      }
  }
  .member {
      height: 32px;
      margin: 18px 6px 10px;
      .head {
          display: inline-block;
          vertical-align: top;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          overflow: hidden;
          background: #fff;
          position: relative;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-image: url("../image/default_custmerIcon.png");
          .defaultImg,image {
              width: 100%;
              height: 100%;
              position: absolute;
              left: 0;
              top: 0;
          }
          .defaultImg {
              font-size: 34px;
              color: #DCDCDC;
              text-align: center;
              line-height: 34px;
          }
      }
      .name {
          display: inline-block;
          vertical-align: top;
          font-weight: 700;
          font-size: 16px;
          color: #000000;
          margin-left: 9px;
          line-height: 32px;
          height: 32px;
          max-width: 60%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
      }
      .privilege {
          display: inline-block;
          vertical-align: top;
          width: 55px;
          height: 18px;
          border-radius: 18px;
          background-image: linear-gradient(102deg, #706D67 0%, #37342F 99%, #251E15 99%);
          font-size: 12px;
          font-weight: bold;
          color: #DDBB86;
          line-height: 18px;
          margin: 7px 0 7px 5px;
          text-align: center;
          .s-iconfont {
              font-size: 12px;
              font-weight: normal;
              margin: 0 2px 0 0px;
          }
      }
  }
  .property {
      height: 30px;
      font-size: 0;
      text-align: center;
      position: relative;
      .item {
          display: inline-block;
          vertical-align: top;
          width: 25%;
          font-weight: 400;
          font-size: 12px;
          color: #333333;
          line-height: 30px;
          height: 30px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          text {
              display: inline-block;
              vertical-align: top;
              line-height: 30px;
          }
          .value {
              font-size: 16px;
              margin-left: 5px;
          }
          .getEnvelop {
              position: absolute;
              top: -16px;
              left: 60%;
              font-size: 12px;
              color: #fff;
              width: 60px;
              height: 18px;
              line-height: 18px;
              text-align: center;
              border-radius: 17px 17px 17px 0;
              background-color: #E93753;
          }
      }
  }
}
</style>
